import {ensureRankersNamespace, RankersNamespaceKey} from "./rankers_namespace";

export const RankersUserAgentHeaderKey = 'RankersUserAgent';


/**
 * Retrieve the Rankers user agent header value from the global window object.
 * This value is set on every page load (see `/app/views/layouts/shared/_head.html.erb`) using `setRankersUserAgent`.
 * @returns {*|null}
 */
export function getRankersUserAgent() {
    if (!window[RankersNamespaceKey]) return null;
    if (!window[RankersNamespaceKey][RankersUserAgentHeaderKey]) return null;
    return window[RankersNamespaceKey][RankersUserAgentHeaderKey];
}
/**
 * Set the Rankers user agent header value on the global window object.
 * This value is used by our JS libraries to set the 'X-Rankers-User-Agent' header on all requests.
 * @returns {*|null}
 */
export function setRankersUserAgent(userAgent) {
    ensureRankersNamespace();
    window[RankersNamespaceKey][RankersUserAgentHeaderKey] = userAgent;
    return window[RankersNamespaceKey][RankersUserAgentHeaderKey];
}
